import { mapState, mapActions, mapMutations } from 'vuex';

const instantMessagingMixin = {
	computed: {
		...mapState('instantMessaging', ['currentConversation'])
	},
	watch: {},
	created () {
		this.initListener();
		if (process.env.NODE_ENV === 'development') {
			const that = this;
			window.onbeforeunload = function (event) {
				that.updateReady(false);
			};
		}
	},
	mounted () {
	},
	beforeDestroy () {
		this.cancelListener();
	},
	methods: {
		...mapActions('instantMessaging', [
			'getMessageList',
			'updateGroupList'
		]),
		...mapMutations('instantMessaging', [
			'showMessage',
			'pushCurrentMessageList',
			'updateConversationList',
			'updateCurrentUserProfile',
			'updateReady'
		]),
		initListener () {
			// READY状态变更
			this.tim.on(this.TIM.EVENT.SDK_READY, this.onReadyStateUpdate, this);
			this.tim.on(this.TIM.EVENT.SDK_NOT_READY, this.onReadyStateUpdate, this);
			// 被踢出
			this.tim.on(this.TIM.EVENT.KICKED_OUT, this.onKickOut);
			// SDK内部出错
			this.tim.on(this.TIM.EVENT.ERROR, this.onError);
			// 收到新消息
			this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage);
			// 会话列表更新
			this.tim.on(this.TIM.EVENT.CONVERSATION_LIST_UPDATED, this.onUpdateConversationList);
			// 群组列表更新
			this.tim.on(this.TIM.EVENT.GROUP_LIST_UPDATED, this.onUpdateGroupList);
			// 网络监测
			this.tim.on(this.TIM.EVENT.NET_STATE_CHANGE, this.onNetStateChange);
		},
		cancelListener () {
			this.tim.off(this.TIM.EVENT.SDK_READY, this.onReadyStateUpdate, this);
			this.tim.off(this.TIM.EVENT.SDK_NOT_READY, this.onReadyStateUpdate, this);
			this.tim.off(this.TIM.EVENT.KICKED_OUT, this.onKickOut);
			this.tim.off(this.TIM.EVENT.ERROR, this.onError);
			this.tim.off(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage);
			this.tim.off(this.TIM.EVENT.CONVERSATION_LIST_UPDATED, this.onUpdateConversationList);
			this.tim.off(this.TIM.EVENT.GROUP_LIST_UPDATED, this.onUpdateGroupList);
			this.tim.off(this.TIM.EVENT.NET_STATE_CHANGE, this.onNetStateChange);
		},
		onReadyStateUpdate ({ name }) {
			const isSDKReady = name === this.TIM.EVENT.SDK_READY;
			console.log(`SDK 进入 ${isSDKReady ? 'ready' : 'noReady'} 状态`);

			this.updateReady(isSDKReady);
			if (isSDKReady) {
				this.tim.getMyProfile()
					.then(({ data }) => {
						this.updateCurrentUserProfile(data)
					})
					.catch(error => {
						this.showMessage({
							type: 'error',
							message: error.message
						})
					})
			}
		},
		onKickOut (event) {
			this.showMessage({
				message: `${this.kickedOutReason(event.data.type)}被踢出`,
				type: 'danger'
			})
		},
		onError (data) {
			if (data.message !== 'Network Error') {
				this.showMessage({
					message: data.message,
					type: 'danger'
				})
			}
		},
		onReceiveMessage ({ data: messageList }) {
			this.handleQuitGroupTip(messageList);
			this.pushCurrentMessageList(messageList);
		},
		onUpdateConversationList (event) {
			this.updateConversationList(event.data);
		},
		onUpdateGroupList (event) {
			this.updateGroupList(event.data)
		},
		onNetStateChange (event) {
			// this.showMessage(this.checkoutNetState(event.data.state))
		},
		kickedOutReason (type) {
			switch (type) {
				case this.TIM.TYPES.KICKED_OUT_MULT_ACCOUNT:
					return '由于多实例登录';
				case this.TIM.TYPES.KICKED_OUT_MULT_DEVICE:
					return '由于多设备登录';
				case this.TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED:
					return '由于 userSig 过期';
				default:
					return ''
			}
		},
		checkoutNetState (state) {
			switch (state) {
				case this.TIM.TYPES.NET_STATE_CONNECTED:
					return { message: '已接入网络', type: 'success' };
				case this.TIM.TYPES.NET_STATE_CONNECTING:
					return { message: '当前网络不稳定', type: 'warning' };
				case this.TIM.TYPES.NET_STATE_DISCONNECTED:
					return { message: '当前网络不可用', type: 'danger' };
				default:
					return ''
			}
		},
		/**
		 * 收到有群成员退群/被踢出的groupTip时，需要将相关群成员从当前会话的群成员列表中移除
		 * @param {Message[]} messageList
		 */
		handleQuitGroupTip (messageList) {
			// 筛选出当前会话的退群/被踢群的 groupTip
			const groupTips = messageList.filter(message => {
				return this.currentConversation.conversationID === message.conversationID &&
					message.type === this.TIM.TYPES.MSG_GRP_TIP &&
					(message.payload.operationType === this.TIM.TYPES.GRP_TIP_MBR_QUIT ||
						message.payload.operationType === this.TIM.TYPES.GRP_TIP_MBR_KICKED_OUT)
			});
		}
	}
};

export default instantMessagingMixin
